import moment from 'moment'
import { getAddresWithLatLong } from '../../store/common/common_action'
import { aadharRegex, API_CACHE_DURATION, daysOfWeek, driverLicenseRegex, monthNames, panCardRegex } from './constants'
import { encrypt } from './loginDecode'
import S3 from 'react-aws-s3'
import { ReactS3ClientConfig } from '../../Utils/ReactS3Client'
import CryptoJS from 'crypto-js'
import { STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { getOtherCharges, splitProportionally } from './bookingHelper'
import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, useTheme } from '@mui/material'
import { modalAtom } from './jotaiState/globalStateAtoms'
import { useAtom } from 'jotai'
import { CheckCircle, Pending } from '@mui/icons-material'
import Modal from './modal'

export const FOCUS = 1
export const colors = ['#D0F1D2', '#FFE0EA', '#FFFDAF', '#FFE0BD', '#E2E3F3', '#E8FAE9', '#FFEFF4', '#C3F8FF','', '#EEEEF8']
export const paymentColors = ['#FFFFFF', '#0C961F', '#995B00', '#98009A', '#E14479', '#326394', '#5FAD09', '#E58900', '#0997CA', '#FFA31A', '#3566CB']
export const NUMERIC_DATA_TYPES = ['number','quantity','currency'];
const monthMap = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11,
}
export const handleKeyPress = (e, nextId, task) => {
  if (e.key == 'Enter' && task === FOCUS) {
    document.getElementById(nextId).focus()
  }
}
export const focusElemnt = (elementID) => {
  elementID && document.getElementById(elementID) && document.getElementById(elementID).focus()
}
export const clickElement = (elementID) => {
  elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
}
export const navigation1 = (e, nextId, prevId) => {
  if (e.key === 'Escape') {
    focusElemnt(prevId)
  }
  if (e.key === 'Enter') {
    focusElemnt(nextId)
    e.preventDefault()
  }
}
export const navigation2 = (e, nextId, prevId) => {
  if (e.key === 'Escape') {
    focusElemnt(prevId)
  }
  if (e.key === 'Enter') {
    focusElemnt(nextId)
  }
}
export const navigation3 = (e, nextId, prevId, clickFunction) => {
  if (e.key === 'Escape') {
    focusElemnt(prevId)
  }
  if (e.key === 'Enter') {
    focusElemnt(nextId)
    e.preventDefault()
  }
  if (e.keyCode === 32) {
    clickFunction()
  }
}
export const navigation4 = (e, nextId, prevId) => {
  if (e.key === 'Escape') {
    requestAnimationFrame(() => {
      focusElemnt(prevId)
    })
  }

  if (e.key === 'Enter') {
    e.preventDefault()
    requestAnimationFrame(() => {
      focusElemnt(nextId)
    })
  }
}
export const lineInputNavigation = (e, nextId, prevId) => {
  if (e.key === 'Escape' || e.key === 'ArrowUp') {
    focusElemnt(prevId)
  }
  if (e.key === 'Enter' || e.key === 'ArrowDown') {
    focusElemnt(nextId)
    e.preventDefault()
  }
}
export const lineInputNavigation3 = (e, nextId, prevId, clickedAction) => {
  if (e.key === 'ArrowUp') {
    focusElemnt(prevId)
  }
  if (e.key === 'ArrowDown') {
    focusElemnt(nextId)
    e.preventDefault()
  }
  if (e.key === 'Enter') {
    clickElement(clickedAction)
  }
}
export const lineInputNavigation2 = (e, nextId, prevId) => {
  if (e.key === 'Escape' || e.key === 'ArrowUp') {
    focusElemnt(prevId)
  }
  if (e.key === 'Enter' || e.key === 'ArrowDown') {
    focusElemnt(nextId)
  }
}
export const singleInputKeyDown = (e, nextId, inputClose) => {
  if (e.key === 'Escape') {
    inputClose()
  }
  if (e.key === 'Enter') {
    e.preventDefault()
    focusElemnt(nextId)
  }
}
export const getText = (string) => {
  return string.replace(/[^a-zA-Z0-9 ]/g, '')
}
export const alphaNumericSpaceFilter = (value = '') => {
  return (value + '').replace(/[^a-zA-Z0-9\s]/gi, '')
}
export const getInt = (numberString) => {
  numberString=numberString+''
  numberString = numberString.replace(/\D/g, '')
  return numberString.length ? parseInt(numberString) : ''
}
export const getIntWith1Dash = (value) => {
  if (!['number', 'string', 'bigint'].includes(typeof value))
      return '';
  value = value.toString();
  value = value.replace(/[^-\d]+/g, '')
  const firstDashIndex = value.indexOf('-');
  if (firstDashIndex === -1 || firstDashIndex === value.length - 1)
      return value;
  return value.slice(0, firstDashIndex + 1) + value.slice(firstDashIndex + 1).replace(/\D/g, '');
};
export const getPhone = (numberString,limit=0) => {
  let sanitizedString = numberString.replace(/[^\d+\-]/g, '');
  sanitizedString = sanitizedString.replace(/(?<=.)\+/g, '');
  sanitizedString = sanitizedString.replace(/^(-)/, '')
  let hyphenCount = 0;
  sanitizedString = sanitizedString.replace(/-/g, (match) => {
    hyphenCount++;
    return hyphenCount === 1 ? match : '';
  });
  if (limit > 0) {
    let maxLength = limit;
    const symbolCount = (sanitizedString.match(/[+\-]/g) || []).length;
    if (symbolCount > 0) {
      maxLength += symbolCount; // Add symbol count to max length
    }
    sanitizedString = sanitizedString.slice(0, maxLength);
  }
  return sanitizedString;
};


export const getIntWithoutLeadingZero = (numberString) => {
  if (!numberString) {
    return 0 // Return an empty string if no value is passed
  }
  numberString = numberString + ''
  numberString = numberString.replace(/\D/g, '')
  numberString = numberString.replace(/^0+/, '')
  return numberString.length ? parseInt(numberString) : ''
}
export const validateAadhar = (val) => {
  return aadharRegex.test(val)
}
export const validatePan = (val) => {
  return panCardRegex.test(val)
}
export const validateDL = (val) => {
  return driverLicenseRegex.test(val)
}
export const disableInput = (val) => {
  return ''
}
const validateLastNumberOfVehicle = (input='')=>{
  const {length}=input
  if (length === 0) return '';
  const lastChar = input[length - 1];
  if([1,2,5,6].includes(input.length)){
    if(/^[A-Z]$/.test(lastChar))
      return input
  }
  if([3,4,7,8,9,10].includes(input.length)){
    if(/^[0-9]$/.test(lastChar))
      return input
  }
  return validateLastNumberOfVehicle(input.slice(0,-1))
}
export const sanitizeVehicleNumber =(input)=> {
  if(!input) return ''
  input = ""+input.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(-10);
  return validateLastNumberOfVehicle(input)
}
export const getFloat = (numberString) => {
  numberString = (numberString + '').replace(/[^0-9.]/g, '')
  numberString = numberString.replace(/(\..*?)\./g, '$1');
  return numberString.length ? parseFloat(numberString) : ''
}
export const getSignedFloat = (value) => {
  let cleaned = (value + '')
    .replace(/[^0-9.-]/g, '')     
    .replace(/(?!^)-/g, '')     
    .replace(/(\..*?)\./g, '$1');
  return cleaned; 
};
export const floatFilter = (input, limit = 0) => {
  if (!input) return "";
  let result = "";
  let hasDot = false;
  let hasSign = false;
  for (let i = 0; i < input.length; i++) {
    const ch = input[i];
    if (ch === "-" && i === 0 && !hasSign) {
      hasSign = true;
      result += ch;
      continue;
    }
    if (ch === "." && !hasDot) {
      hasDot = true;
      result += ch;
      continue;
    }
    if (ch >= "0" && ch <= "9") {
      result += ch;
      continue;
    }
  }
  if (result === ".") return "0.";
  if (result === "-.") return "-0.";
  const isNegative = result.startsWith("-");
  const hasTrailingDot = result.endsWith(".");
  let numeric = isNegative ? result.slice(1) : result;
  let [intPart, decPart = ""] = numeric.split(".");
  intPart = intPart.replace(/^0+(?=\d)/, "");
  if (limit > 0) {
    decPart = decPart.slice(0, limit);
  }
  let output = (isNegative ? "-" : "") + intPart;
  if (hasTrailingDot) {
    output += ".";
  } else if (decPart) {
    output += "." + decPart;
  }
  return output;
};


export const getFloat1 = (inputString) => {
  inputString = inputString.trim();
  if (inputString === '') return '';
  var pattern = /^[0-9.]+$/;
  return pattern.test(inputString) ? inputString : (inputString + '').replace(/[^0-9.]/g, '');

}
export const float = (num) => {
  const value = parseFloat(num) || 0; 
  return parseFloat((Math.round((value + Number.EPSILON) * 100) / 100).toString());
};
export const manualLr = (string) => {
  return string.replace(/[^0-9\-]/g, '')
}
export const openInNewWindow = (html) => {
  try {
    let tab = window.open('about:blank', '_blank')
    tab.document.write(html)
    tab.document.close()
  } catch (e) {
    // console.log(e)
  }
}
function convertNumberToWords(amount) {
  var words = new Array()
  words[0] = ''
  words[1] = 'One'
  words[2] = 'Two'
  words[3] = 'Three'
  words[4] = 'Four'
  words[5] = 'Five'
  words[6] = 'Six'
  words[7] = 'Seven'
  words[8] = 'Eight'
  words[9] = 'Nine'
  words[10] = 'Ten'
  words[11] = 'Eleven'
  words[12] = 'Twelve'
  words[13] = 'Thirteen'
  words[14] = 'Fourteen'
  words[15] = 'Fifteen'
  words[16] = 'Sixteen'
  words[17] = 'Seventeen'
  words[18] = 'Eighteen'
  words[19] = 'Nineteen'
  words[20] = 'Twenty'
  words[30] = 'Thirty'
  words[40] = 'Forty'
  words[50] = 'Fifty'
  words[60] = 'Sixty'
  words[70] = 'Seventy'
  words[80] = 'Eighty'
  words[90] = 'Ninety'
  amount = amount.toString()
  var atemp = amount.split('.')
  var number = atemp[0].split(',').join('')
  var n_length = number.length
  var words_string = ''
  if (n_length <= 9) {
    var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0)
    var received_n_array = new Array()
    for (var i = 0; i < n_length; i++) {
      received_n_array[i] = number.substr(i, 1)
    }
    for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
      n_array[i] = received_n_array[j]
    }
    for (var i = 0, j = 1; i < 9; i++, j++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        if (n_array[i] == 1) {
          n_array[j] = 10 + parseInt(n_array[j])
          n_array[i] = 0
        }
      }
    }
    let value = ''
    for (var i = 0; i < 9; i++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        value = n_array[i] * 10
      } else {
        value = n_array[i]
      }
      if (value != 0) {
        words_string += words[value] + ' '
      }
      if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
        words_string += 'Crores '
      }
      if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
        words_string += 'Lakhs '
      }
      if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
        words_string += 'Thousand '
      }
      if (i == 6 && value != 0 && n_array[i + 1] != 0 && n_array[i + 2] != 0) {
        words_string += 'Hundred and '
      } else if (i == 6 && value != 0) {
        words_string += 'Hundred '
      }
    }
    words_string = words_string.split('  ').join(' ')
  }
  return words_string
}

export const withDecimal = (n) => {
  var nums = n?.toString()?.split('.')
  var whole = convertNumberToWords(nums[0])
  if (nums.length == 2) {
    var fraction = convertNumberToWords(nums[1])
    return whole + 'point ' + fraction
  } else {
    return whole
  }
}
export const getRevDate = (date) => {
  var val = date.split(',')[0]
  return (
    val.split('/')[2] +
    '-' +
    (val.split('/')[0] < 10 ? '0' + val.split('/')[0] : val.split('/')[0]) +
    '-' +
    (val.split('/')[1] < 10 ? '0' + val.split('/')[1] : val.split('/')[1])
  )
}

export const getDate = (date) => {
  var dt = date.toString().split(' ')
  return dt[0] + ', ' + dt[2] + '-' + dt[1] + '-' + dt[3].substr(2) + ' ' + dt[4].substr(0, 5)
}

export const getSearchParams = () => {
  const data = {}
  const param =
    decodeURIComponent(window.location.search).split('?').length > 1 ? decodeURIComponent(window.location.search).split('?')[1] : false
  const pairs = param ? param.split('&') : []
  for (let i = 0; i < pairs.length; i++) {
    pairs[i] = pairs[i].split('=')
    data[pairs[i][0]] = pairs[i][1]
  }
  return data
}
export const removeByIndex = (arr, index) => {
  return arr.filter(function (el, i) {
    return index !== i
  })
}
export const getSearchParamsV2 = () => {
  const param =
    decodeURIComponent(window.location.search).split('?').length > 1 ? decodeURIComponent(window.location.search).split('?')[1] : false
  const urlParamsStrArr = param ? param.split('&') : []
  let urlParams = {}
  urlParamsStrArr.map((value) => {
    const paramArr = value.split('=')
    urlParams = {
      ...urlParams,
      [paramArr[0]]: value.substring(paramArr[0].length + 1),
    }
  })
  return urlParams
}
export const appendToUrl = (url, urlParams) => {
  let queryParams = ''
  if (typeof urlParams != 'undefined' && !isEmpty(urlParams)) {
    Object.entries(urlParams).forEach((entry, i, { length }) => {
      const [key, value] = entry
      if (i === length - 1) {
        queryParams += `${key}=${encodeURIComponent(value)}`
      } else {
        queryParams += `${key}=${encodeURIComponent(value)}&`
      }
    })
    url = `${url}${queryParams}`
  }
  return url
}

export const randomString = (len, charSet) => {
  charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var randomString = ''
  for (var i = 0; i < len; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length)
    randomString += charSet.substring(randomPoz, randomPoz + 1)
  }
  return randomString
}

export const getSumOfArr = (arr = []) => arr.reduce((pVal, cVal) => pVal + cVal, 0)

export const updateObjArrayAtSpfcInd = (arr, index, key, newValue) => [
  ...arr.slice(0, index),
  {
    // here update data value
    ...arr[index],
    [key]: newValue,
  },
  ...arr.slice(index + 1),
]
export const getConsignmentUpdateData = (ModifyData, priceSectionData, selectLr, ModifyData1, loginData, additionalChrg, CCR, cmnt, selectedMethod) => {
  let strAllConsignmentSubTypeID,
    strAllDescription,
    strAllQuantity,
    strAllGoodsValue,
    strAllVolume,
    strAllActualWeight,
    strAllActualRate,
    strAllChargedWeight,
    strAllRate,
    strAllFreight,
    strAllAmount,
    strAllMOPID,
    strBookingDetID,
    strBookingID
  strAllConsignmentSubTypeID = strAllDescription = strAllQuantity = strAllGoodsValue = strAllVolume = strAllActualWeight = ''
  strAllChargedWeight = strAllActualRate = strAllRate = strAllFreight = strAllAmount = strAllMOPID = strBookingDetID = strBookingID = ''
  ModifyData.map((item, index, { length }) => {
    if (Object.keys(item.length != 0)) {
      if (index === 0) {
        strAllConsignmentSubTypeID += '' + item.ConsignmentSubTypeID
        strAllDescription += '' + item.Description
        strAllQuantity += '' + item.Quantity
        strAllGoodsValue += '' + item.GoodsValue
        strAllVolume += '' + item.Volume
        strAllActualWeight += '' + item.ActualWeight
        strAllChargedWeight += '' + item.ChargedWeight
        strAllActualRate += '' + item.Rate
        strAllRate += '' + item.Rate
        strAllFreight += '' + item.Freight
        strAllAmount += '' + priceSectionData.freight
        strAllMOPID += '' + item.Mopid
        strBookingDetID += '' + item.BookingDetID
        strBookingID += '' + item.BookingID
      } else {
        strAllConsignmentSubTypeID += '||' + item.ConsignmentSubTypeID
        strAllDescription += '||' + item.Description
        strAllQuantity += '||' + item.Quantity
        strAllGoodsValue += '||' + item.GoodsValue
        strAllVolume += '||' + item.Volume
        strAllActualWeight += '||' + item.ActualWeight
        strAllChargedWeight += '||' + item.ChargedWeight
        strAllActualRate += '||' + item.Rate
        strAllRate += '||' + item.Rate
        strAllFreight += '||' + item.Freight
        strAllAmount += '||' + priceSectionData.freight
        strAllMOPID += '||' + item.Mopid
        strBookingDetID += '||' + item.BookingDetID
        strBookingID += '||' + item.BookingID
      }
    }
  })
  return {
    BookingID: selectLr?.BookingID,
    CompanyID: ModifyData1[0]?.CompanyID,
    Items: parseInt(ModifyData[0]?.Quantity, 10),
    Freight: priceSectionData.freight,
    DocumentCharges: priceSectionData.doc_fee,
    ServiceTaxAmount: priceSectionData.gst,
    Insurance: priceSectionData.valuation,
    CollectionCharges: priceSectionData.pickup_fee,
    DeliveryCharges: 0,
    CartageAmount: priceSectionData.coll_cartage,
    HamaliCharges: priceSectionData.hamali,
    DoorDelCharges: 0,
    NetAmount: priceSectionData.gross_amount,
    CartageDelAmount: priceSectionData.del_cartage,
    strAllConsignmentSubTypeID: strAllConsignmentSubTypeID,
    strAllDescription: strAllDescription,
    strAllQuantity: strAllQuantity,
    strAllGoodsValue: strAllGoodsValue,
    strAllVolume: strAllVolume,
    strAllActualWeight: strAllActualWeight,
    strAllChargedWeight: strAllChargedWeight,
    strAllActualRate: strAllActualRate,
    strAllRate: strAllRate,
    strAllFreight: strAllFreight,
    strAllAmount: strAllAmount,
    strAllMOPID: strAllMOPID,
    strBookingID: strBookingID,
    strBookingDetID: strBookingDetID,
    LoggedInUserID: loginData.intUserID,
    OptHamaliCharges: priceSectionData.op_hamali,
    PickUpChg: priceSectionData.pickup_fee,
    DropOffChg: priceSectionData.dropoff_fee,
    PickupCartage: priceSectionData.CCBrkup_pckp,
    CommCartage: priceSectionData.CCBrkup_cmsn,
    ReturnCartage: priceSectionData.CCBrkup_rtrn,
    ConvenienceCharge: additionalChrg,
    CartageRemarks: CCR,
    Remarks: cmnt,
    ModeOfPayment: selectedMethod?.ModeID || 0,
    GSTAmount: priceSectionData?.GSTAmount || 0,
  }
}
export const getbookingData = (
  IsRateIncludeAllCharge,
  strtCity,
  strtBrnch,
  destCity,
  destBrnch,
  selBookingType,
  slctdSndParty,
  slctdRcvrParty,
  sendName,
  senCNnST,
  sendMobNo,
  recName,
  recCNnST,
  recMobNo,
  consignmntData,
  priceSectionData,
  gstPaidBy,
  CCR,
  refrenceId,
  accountNo,
  selectedMethod,
  sendMailId,
  recMailId,
  senGstnNo,
  recGstnNo,
  billNo,
  billAmount,
  pickupAddressObj,
  deliveryAddressObj,
  focApproverUser,
  loginData,
  ManualLR,
  ewayBillNoList,
  SenderIDProofID,
  ReceiverIDProofID,
  SelfBookingPNRNo,
  sendMobNo2,
  recMobNo2,
  senderGSTNdata,
  receiverGSTNdata,
  isRCM,
  taxableAmount,
  additionalChrg,
  PickupBranchID,
  DropOffBranchID,
  PickupCityID,
  DropOffCityID,
  IsFTLOrPTL,
  isExmpted,
  exemptedReason,
  cmnt,
  sendISDCode,
  RecISDCode,
  rateIncrease,
  paymentResponsible
) => {
  const isSendParty = !isEmpty(slctdSndParty)
  const isRecParty = !isEmpty(slctdRcvrParty)
  const allFreights = consignmntData.map((a) => parseFloat(a.freight) || 0)
  const rateIncreaseamount = rateIncrease?.IsDefaultRateIncreasedBy ? rateIncrease?.DefaultRateIncreaseAmt || 0 : 0
  const proportionalArr = splitProportionally(allFreights, rateIncreaseamount)
  const value = IsRateIncludeAllCharge ? getOtherCharges(priceSectionData) : 0
  const reducingAmountArr = splitProportionally(allFreights, value)
  var today = new Date()
  var date = today.toLocaleDateString('en-US').split('/').reverse().join('-')
  var strbillNo = billNo ? billNo + `~` + date : ''
  let AllActualRate,
    AllActualWeight,
    AllAmount,
    AllChargedWeight,
    AllConsignmentSubTypeID,
    AllCurrentBranch,
    AllCurrentCity,
    AllDescription,
    AllFreight,
    AllGoodsValue,
    AllMOPID,
    AllQuantity,
    AllRate,
    AllVolume

  AllActualRate = AllActualWeight = AllAmount = AllChargedWeight = AllConsignmentSubTypeID = AllCurrentBranch = ''
  AllCurrentCity = AllDescription = AllFreight = AllGoodsValue = AllMOPID = AllQuantity = AllRate = AllVolume = ''
  let intTotalQty = 0
  let totalWeigtcharge = 0
  let AllLength = ''
  let AllWidth  = ''
  let AllHeight = ''
  consignmntData.map((item, index, { length }) => {
    if (Object.keys(item.slctdCnsgnmntType).length != 0) {
      if (index === 0) {
        AllActualRate += '' + item.rate
        AllActualWeight += '' + item.wt_actual
        AllAmount += '' + priceSectionData.gross_amount
        AllChargedWeight += '' + item.wt_charge
        AllConsignmentSubTypeID += '' + item.slctdCnsgnmntType.ConsignmentSubTypeID
        AllCurrentBranch += '' + strtBrnch?.BranchID
        AllCurrentCity += '' + strtCity?.CityID
        AllDescription += '' + item.description
        AllFreight += '' + (item.freight+proportionalArr[index] - reducingAmountArr[index])
        AllGoodsValue += '' + item.goods_value
        AllMOPID += '' + item?.slctdMethodOfPckgType?.MOPID
        AllQuantity += '' + item.unit
        AllRate += '' + item.rate
        AllVolume += '' + item.wt_volume
        AllLength +=  '' + (item.wt_vlm_len || 0)
        AllWidth += '' +(item.wt_vlm_wid || 0) 
        AllHeight += '' +(item.wt_vlm_ht || 0)
      } else {
        AllActualRate += '||' + item.rate
        AllActualWeight += '||' + item.wt_actual
        AllAmount += '||' + priceSectionData.gross_amount
        AllChargedWeight += '||' + item.wt_charge
        AllConsignmentSubTypeID += '||' + item.slctdCnsgnmntType.ConsignmentSubTypeID
        AllCurrentBranch += '||' + strtBrnch?.BranchID
        AllCurrentCity += '||' + strtCity?.CityID
        AllDescription += '||' + item.description
        AllFreight += '||' + (item.freight + proportionalArr[index] - reducingAmountArr[index])
        AllGoodsValue += '||' + item.goods_value
        AllMOPID += '||' + item?.slctdMethodOfPckgType?.MOPID
        AllQuantity += '||' + item.unit
        AllRate += '||' + item.rate
        AllVolume += '||' + item.wt_volume
        AllLength += '||' + (item.wt_vlm_len || 0)
        AllWidth += '||' + (item.wt_vlm_wid || 0)
        AllHeight += '||' + (item.wt_vlm_ht || 0)
      }
      intTotalQty += parseInt(item.unit)
      totalWeigtcharge += parseFloat(item.wt_charge)
    }
  })
  const ceildTotalPayble = Math.ceil(priceSectionData.gross_amount / 5) * 5
  let ceilValue = 0
  if (loginData.intCompanyID === STA_COMPANY_ID) {
    ceilValue = ceildTotalPayble - priceSectionData.gross_amount
  }
  return {
    BookingID: 0,
    CompanyID: loginData.intCompanyID,
    BookingCityID: strtCity?.CityID || loginData.intBranchCityID,
    BookingBranchID: strtBrnch?.BranchID || loginData.intBranchID,
    DestinationCityID: destCity?.CityID,
    DestinationBranchID: destBrnch?.BranchID,
    PaymentType: selBookingType?.typeId,
    IsEnvelop: 0,
    IsSenderParty: isSendParty ? 1 : 0,
    IsReceivedParty: isRecParty ? 1 : 0,
    IsBilled: 0,
    IsAgentBooking: 0,
    IsSenderAlertMobile: 1,
    IsRecAlertMobile: 1,
    IsRefund: 0,
    AgentID: 0,
    SenderPartyID: isSendParty ? slctdSndParty?.PartyID : 0,
    Sender: isSendParty ? slctdSndParty?.Party : sendName,
    SenderAddress: isSendParty ? slctdSndParty?.Address : senCNnST,
    ContactPerson: '',
    SenderMobileNo: isSendParty ? slctdSndParty?.MobileNo : sendMobNo,
    PartyBillNo: strbillNo,
    RecPartyID: isRecParty ? slctdRcvrParty?.PartyID : 0,
    recName: isRecParty ? slctdRcvrParty?.Party : recName,
    RecAddress: isRecParty ? slctdRcvrParty?.Address : recCNnST,
    RecContactPerson: '',
    RecMobileNo: isRecParty ? slctdRcvrParty?.MobileNo : recMobNo,
    Itmes: intTotalQty,
    Freight: priceSectionData.freight,
    DocumentCharges: priceSectionData.doc_fee,
    ServiceTaxAmount: priceSectionData.gst,
    Insurance: priceSectionData.valuation,
    CollectionCharges: 0,
    CartageAmount: +priceSectionData?.coll_cartage + ceilValue,
    NetAmount: +priceSectionData.gross_amount + +ceilValue,
    RefundAmount: 0,
    Remarks: cmnt || '',
    IsMovement: 0,
    UserID: loginData.intUserID,
    IsCancelled: 0,
    IsCurrent: 1,
    IsDeleted: 0,
    IsPrinted: 0,
    ModeOfPayment: selectedMethod?.ModeID || 1, //todo handle mode of payment
    GUID: '',
    DeliveryCharges: 0,
    DeliveryType: 1, //todo handle delivery type dynamic
    CollectionType: 0,
    ManualLR: ManualLR, //
    HamaliCharges: priceSectionData.hamali,
    DoorDelCharges: 0,
    CrossingCityID: 0,
    CrossingBranchID: 0,
    StaxPaidBy: gstPaidBy.srvcTaxPayerCode,
    BlockedLR: '',
    CartageDelAmount: priceSectionData?.del_cartage || 0,
    CartageRemarks: CCR,
    SenderEmailID: isSendParty ? slctdSndParty?.EmailID : sendMailId,
    ReceiverEmailID: isRecParty ? slctdRcvrParty?.EmailID : recMailId,
    IsOfflineBooking: 0,
    VehicleNo: '',
    SenderGSTN: senGstnNo || '',
    ReceiverGSTN: recGstnNo || '',
    IDProofTypeID: SenderIDProofID?.IdProofType?.IDProofid || 0, //todo fix data
    IDProofNo: SenderIDProofID?.IdProof || 0, //todo fix data
    OfflineVehicleID: 0,
    AllConsignmentSubTypeID: AllConsignmentSubTypeID,
    AllDescription: AllDescription,
    AllQuantity: AllQuantity,
    AllGoodsValue: AllGoodsValue,
    AllVolume: AllVolume,
    AllActualWeight: AllActualWeight,
    AllChargedWeight: AllChargedWeight,
    AllActualRate: AllActualRate,
    AllRate: AllRate,
    AllFreight: AllFreight,
    AllAmount: AllAmount,
    AllCurrentCity: AllCurrentCity,
    AllCurrentBranch: AllCurrentBranch,
    AllMOPID: AllMOPID,
    AllLength: AllLength,
    AllWidth: AllWidth,
    AllHeight: AllHeight,
    PickupCityID: 0,
    DropOffCityID: 0,
    EwayBillNo: ewayBillNoList.join(',') || '',
    PickupCartage: priceSectionData.CCBrkup_pckp,
    CommCartage: +priceSectionData.CCBrkup_cmsn + ceilValue,
    ReturnCartage: priceSectionData.CCBrkup_rtrn,
    LoggedInUserID: loginData.intUserID,
    BillAmount: billAmount,
    FOCApprovalAuthority: focApproverUser?.UserName || '',
    SenderIDProofNo: SenderIDProofID?.IdProof || 0,
    ReceiverIDProofNo: SenderIDProofID?.IdProof || 0,
    SenderIDProofID: SenderIDProofID?.IdProofType?.IDProofid || 0,
    ReceiverIDProofID: ReceiverIDProofID?.IdProofType?.IDProofid || 0,
    SelfBookingPNRNo: SelfBookingPNRNo || 0,
    InsuranceProviderID: 0,
    OptHamaliCharges: priceSectionData.op_hamali || 0,
    PickupChg: priceSectionData.pickup_fee || 0,
    DropOffChg: priceSectionData.dropoff_fee || 0,
    SenderPin: pickupAddressObj?.pincode || '',
    ReceiverPin: deliveryAddressObj?.pincode || '',
    SenderContactNo2: sendMobNo2,
    ReceiverContactNo2: recMobNo2,
    PickPhone: pickupAddressObj?.contact || '',
    PickGMapAddress: pickupAddressObj?.GMapAddress || '',
    PickFullAddress: pickupAddressObj?.formatted_address || '',
    PickHouseNumber: pickupAddressObj?.flatNo || '',
    PickHouseAddLine1: pickupAddressObj?.building || '',
    PickInstruction: pickupAddressObj?.howToReach || '',
    DropPhone: deliveryAddressObj?.contact || '',
    DropGMapAddress: deliveryAddressObj?.GMapAddress || '',
    DropFullAddress: deliveryAddressObj?.formatted_address || '',
    DropHouseNumber: deliveryAddressObj?.flatNo || '',
    DropHouseAddLine1: deliveryAddressObj?.building || '',
    DropInstruction: deliveryAddressObj?.howToReach || '',
    senderGSTNState: senderGSTNdata?.State || '',
    recvGSTNState: receiverGSTNdata?.State || '',
    BookingGST: taxableAmount,
    isRCMBooking: isRCM ? 1 : 0,
    AccountNo: accountNo?.AccountNo || '',
    TransactionID: refrenceId,
    ConvenienceCharge: additionalChrg || 0,
    PickupBranchID: PickupBranchID,
    DropOffBranchID: DropOffBranchID,
    PickupCityID: PickupCityID,
    DropOffCityID: DropOffCityID,
    IsFTLOrPTL: IsFTLOrPTL,
    IsExempted: isExmpted ? 1 : 0,
    ExemptedGoodsID: exemptedReason?.ID || 0,
    FOCApprovalUserID: focApproverUser?.UserID || 0,
    SenderCountryCode: sendISDCode?.name,
    RecvCountryCode: RecISDCode?.name,
    IsSenderPartyResp: isSendParty && isRecParty && paymentResponsible === 1 ? 1 : 0,
    IsRecvPartyResp: isSendParty && isRecParty && paymentResponsible === 2 ? 1 : 0,
  }
}
export const getOfflineBookingData = (
  senderCity,
  strtBrnch,
  destCity,
  destBrnch,
  selBookingType,
  slctdSndParty,
  slctdRcvrParty,
  sendName,
  senCNnST,
  sendMobNo,
  recName,
  recCNnST,
  recMobNo,
  consignmntData,
  priceSectionData,
  gstPaidBy,
  CCR,
  refrenceId,
  accountNo,
  selectedMethod,
  sendMailId,
  recMailId,
  senGstnNo,
  recGstnNo,
  billNo,
  billAmount,
  pickupAddressObj,
  deliveryAddressObj,
  focApproverUser,
  loginData,
  ManualLR,
  ewayBillNoList,
  SenderIDProofID,
  ReceiverIDProofID,
  SelfBookingPNRNo,
  sendMobNo2,
  recMobNo2,
  senderGSTNdata,
  receiverGSTNdata,
  isRCM,
  taxableAmount,
  additionalChrg,
  PickupBranchID,
  DropOffBranchID,
  PickupCityID,
  DropOffCityID,
  IsFTLOrPTL,
  isExmpted,
  exemptedReason,
  cmnt,
  sendISDCode,
  RecISDCode,
  selectedVehicle,
  IsBookingBranchUserForOfflineBkng,
  senderUser
) => {
  const string = ''
  const isSendParty = !isEmpty(slctdSndParty)
  const isRecParty = !isEmpty(slctdRcvrParty)
  var today = new Date()
  var date = today.toLocaleDateString('en-US').split('/').reverse().join('-')
  var strbillNo = billNo ? billNo + `~` + date : ''
  let AllActualRate,
    AllActualWeight,
    AllAmount,
    AllChargedWeight,
    AllConsignmentSubTypeID,
    AllCurrentBranch,
    AllCurrentCity,
    AllDescription,
    AllFreight,
    AllGoodsValue,
    AllMOPID,
    AllQuantity,
    AllRate,
    AllVolume

  AllActualRate = AllActualWeight = AllAmount = AllChargedWeight = AllConsignmentSubTypeID = AllCurrentBranch = ''
  AllCurrentCity = AllDescription = AllFreight = AllGoodsValue = AllMOPID = AllQuantity = AllRate = AllVolume = ''
  let intTotalQty = 0
  let totalWeigtcharge = 0
  let AllLength = ''
  let AllWidth  = ''
  let AllHeight = ''
  consignmntData.map((item, index, { length }) => {
    if (Object.keys(item.slctdCnsgnmntType).length != 0) {
      if (index === 0) {
        AllActualRate += '' + item.rate
        AllActualWeight += '' + item.wt_actual
        AllAmount += '' + priceSectionData.gross_amount
        AllChargedWeight += '' + item.wt_charge
        AllConsignmentSubTypeID += '' + item.slctdCnsgnmntType.ConsignmentSubTypeID
        AllCurrentBranch += '' + strtBrnch?.BranchID
        AllCurrentCity += '' + senderCity?.CityID
        AllDescription += '' + item.description
        AllFreight += '' + item.freight
        AllGoodsValue += '' + item.goods_value
        AllMOPID += '' + item?.slctdMethodOfPckgType?.MOPID
        AllQuantity += '' + item.unit
        AllRate += '' + item.rate
        AllVolume += '' + item.wt_volume
        AllLength +=  '' + (item.wt_vlm_len || 0)
        AllWidth += '' +(item.wt_vlm_wid || 0) 
        AllHeight += '' +(item.wt_vlm_ht || 0)
      } else {
        AllActualRate += '||' + item.rate
        AllActualWeight += '||' + item.wt_actual
        AllAmount += '||' + priceSectionData.gross_amount
        AllChargedWeight += '||' + item.wt_charge
        AllConsignmentSubTypeID += '||' + item.slctdCnsgnmntType.ConsignmentSubTypeID
        AllCurrentBranch += '||' + strtBrnch?.BranchID
        AllCurrentCity += '||' + senderCity?.CityID
        AllDescription += '||' + item.description
        AllFreight += '||' + item.freight
        AllGoodsValue += '||' + item.goods_value
        AllMOPID += '||' + item?.slctdMethodOfPckgType?.MOPID
        AllQuantity += '||' + item.unit
        AllRate += '||' + item.rate
        AllVolume += '||' + item.wt_volume
        AllLength += '||' + (item.wt_vlm_len || 0)
        AllWidth += '||' + (item.wt_vlm_wid || 0)
        AllHeight += '||' + (item.wt_vlm_ht || 0)
      }
      intTotalQty += parseInt(item.unit)
      totalWeigtcharge += parseFloat(item.wt_charge)
    }
  })
  const ceildTotalPayble = Math.ceil(priceSectionData.gross_amount / 5) * 5
  let ceilValue = 0
  if (loginData.intCompanyID === STA_COMPANY_ID) {
    ceilValue = ceildTotalPayble - priceSectionData.gross_amount
  }
  return {
    BookingID: 0,
    CompanyID: loginData.intCompanyID,
    BookingCityID: senderCity?.CityID || loginData.intBranchCityID,
    BookingBranchID: strtBrnch?.BranchID || loginData.intBranchID,
    DestinationCityID: destCity?.CityID,
    DestinationBranchID: destBrnch?.BranchID,
    PaymentType: selBookingType?.typeId,
    IsEnvelop: 0,
    IsSenderParty: isSendParty ? 1 : 0,
    IsReceivedParty: isRecParty ? 1 : 0,
    IsBilled: 0,
    IsAgentBooking: 0,
    IsSenderAlertMobile: 1,
    IsRecAlertMobile: 1,
    IsRefund: 0,
    AgentID: 0,
    SenderPartyID: isSendParty ? slctdSndParty?.PartyID : 0,
    Sender: isSendParty ? slctdSndParty?.Party : sendName,
    SenderAddress: isSendParty ? slctdSndParty?.Address : senCNnST,
    ContactPerson: '',
    SenderMobileNo: isSendParty ? slctdSndParty?.MobileNo : sendMobNo,
    PartyBillNo: strbillNo,
    RecPartyID: isRecParty ? slctdRcvrParty?.PartyID : 0,
    recName: isRecParty ? slctdRcvrParty?.Party : recName,
    RecAddress: isRecParty ? slctdRcvrParty?.Address : recCNnST,
    RecContactPerson: '',
    RecMobileNo: isRecParty ? slctdRcvrParty?.MobileNo : recMobNo,
    Itmes: intTotalQty,
    Freight: priceSectionData.freight,
    DocumentCharges: priceSectionData.doc_fee,
    ServiceTaxAmount: priceSectionData.gst,
    Insurance: priceSectionData.valuation,
    CollectionCharges: 0,
    CartageAmount: +priceSectionData?.coll_cartage + ceilValue,
    NetAmount: +priceSectionData.gross_amount + +ceilValue,
    RefundAmount: 0,
    Remarks: cmnt || '',
    IsMovement: 0,
    UserID: IsBookingBranchUserForOfflineBkng===1?senderUser?.UserID:loginData.intUserID,
    IsCancelled: 0,
    IsCurrent: 1,
    IsDeleted: 0,
    IsPrinted: 0,
    ModeOfPayment: selectedMethod?.ModeID || 1, //todo handle mode of payment
    GUID: '',
    DeliveryCharges: 0,
    DeliveryType: 1, //todo handle delivery type dynamic
    CollectionType: 0,
    ManualLR: ManualLR, //
    HamaliCharges: priceSectionData.hamali,
    DoorDelCharges: 0,
    CrossingCityID: 0,
    CrossingBranchID: 0,
    StaxPaidBy: gstPaidBy.srvcTaxPayerCode,
    BlockedLR: '',
    CartageDelAmount: priceSectionData?.del_cartage || 0,
    CartageRemarks: CCR,
    SenderEmailID: isSendParty ? slctdSndParty?.EmailID : sendMailId,
    ReceiverEmailID: isRecParty ? slctdRcvrParty?.EmailID : recMailId,
    IsOfflineBooking: 1,
    VehicleNo: '',
    SenderGSTN: senGstnNo || '',
    ReceiverGSTN: recGstnNo || '',
    IDProofTypeID: SenderIDProofID?.IdProofType?.IDProofid || 0, //todo fix data
    IDProofNo: SenderIDProofID?.IdProof || 0, //todo fix data
    OfflineVehicleID: 0,
    AllConsignmentSubTypeID: AllConsignmentSubTypeID,
    AllDescription: AllDescription,
    AllQuantity: AllQuantity,
    AllGoodsValue: AllGoodsValue,
    AllVolume: AllVolume,
    AllActualWeight: AllActualWeight,
    AllChargedWeight: AllChargedWeight,
    AllActualRate: AllActualRate,
    AllRate: AllRate,
    AllFreight: AllFreight,
    AllAmount: AllAmount,
    AllCurrentCity: AllCurrentCity,
    AllCurrentBranch: AllCurrentBranch,
    AllMOPID: AllMOPID,
    AllLength: AllLength,
    AllWidth: AllWidth,
    AllHeight: AllHeight,
    PickupCityID: 0,
    DropOffCityID: 0,
    EwayBillNo: ewayBillNoList.join(',') || '',
    PickupCartage: priceSectionData.CCBrkup_pckp,
    CommCartage: +priceSectionData.CCBrkup_cmsn + ceilValue,
    ReturnCartage: priceSectionData.CCBrkup_rtrn,
    LoggedInUserID: loginData.intUserID,
    BillAmount: billAmount,
    FOCApprovalAuthority: focApproverUser?.UserName || '',
    SenderIDProofNo: SenderIDProofID?.IdProof || 0,
    ReceiverIDProofNo: SenderIDProofID?.IdProof || 0,
    SenderIDProofID: SenderIDProofID?.IdProofType?.IDProofid || 0,
    ReceiverIDProofID: ReceiverIDProofID?.IdProofType?.IDProofid || 0,
    SelfBookingPNRNo: SelfBookingPNRNo || 0,
    InsuranceProviderID: 0,
    OptHamaliCharges: priceSectionData.op_hamali || 0,
    PickupChg: priceSectionData.pickup_fee || 0,
    DropOffChg: priceSectionData.dropoff_fee || 0,
    SenderPin: pickupAddressObj?.pincode || '',
    ReceiverPin: deliveryAddressObj?.pincode || '',
    SenderContactNo2: sendMobNo2,
    ReceiverContactNo2: recMobNo2,
    PickPhone: pickupAddressObj?.contact || '',
    PickGMapAddress: pickupAddressObj?.GMapAddress || '',
    PickFullAddress: pickupAddressObj?.formatted_address || '',
    PickHouseNumber: pickupAddressObj?.flatNo || '',
    PickHouseAddLine1: pickupAddressObj?.building || '',
    PickInstruction: pickupAddressObj?.howToReach || '',
    DropPhone: deliveryAddressObj?.contact || '',
    DropGMapAddress: deliveryAddressObj?.GMapAddress || '',
    DropFullAddress: deliveryAddressObj?.formatted_address || '',
    DropHouseNumber: deliveryAddressObj?.flatNo || '',
    DropHouseAddLine1: deliveryAddressObj?.building || '',
    DropInstruction: deliveryAddressObj?.howToReach || '',
    senderGSTNState: senderGSTNdata?.State || '',
    recvGSTNState: receiverGSTNdata?.State || '',
    BookingGST: taxableAmount,
    isRCMBooking: isRCM ? 1 : 0,
    AccountNo: accountNo?.AccountNo || '',
    TransactionID: refrenceId,
    ConvenienceCharge: additionalChrg || 0,
    PickupBranchID: PickupBranchID,
    DropOffBranchID: DropOffBranchID,
    PickupCityID: PickupCityID,
    DropOffCityID: DropOffCityID,
    IsFTLOrPTL: IsFTLOrPTL,
    IsExempted: isExmpted ? 1 : 0,
    ExemptedGoodsID: exemptedReason?.ID || 0,
    FOCApprovalUserID: focApproverUser?.UserID || 0,
    SenderCountryCode: sendISDCode?.name,
    RecvCountryCode: RecISDCode?.name,
    VehicleNo:selectedVehicle?.VehicleNo,
    OfflineVehicleID:selectedVehicle?.VehicleID

  }
}

export const isEmpty = (obj) => {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
}
export const isNull = (str) => {
  return typeof str === 'undefined' || str === null || str === ''
}
export const isNonEmpty = (value) => {
  return (typeof value === 'number' && value > 0) || (typeof value === 'string' && value.length > 0 && value !== '0')
}

export const getNum = (val) => {
  return val ? parseInt(val) : 0
}
export const reverseObj = (obj) => {
  let newObj = {}

  Object.keys(obj)
    .sort()
    .reverse()
    .forEach((key) => {
      newObj[key] = obj[key]
    })
  return newObj
}

export const getAddress = () => {
  if (navigator.geolocation) {
    const pos = navigator.geolocation.getCurrentPosition(getAddressbyPosition)
    // console.log(pos)
  } else {
    document.getElementById('demo').innerHTML = 'Geolocation is not supported by this browser.'
  }
}
export const getAddressbyPosition = (position) => {
  var latlong = position.coords.latitude + ',' + position.coords.longitude
  return latlong
}
export const savePickupAddress = (val) => {
  let pickupAddresslist = JSON.parse(localStorage.getItem('pickupAddress') || '[]')
  if (!containsObject(val, pickupAddresslist)) {
    pickupAddresslist.push(val)
  }
  localStorage.setItem('pickupAddress', JSON.stringify(pickupAddresslist))
}
export const savedeliveryAddress = (val) => {
  let deliveryAddressList = JSON.parse(localStorage.getItem('deliveryAddress') || '[]')
  if (!containsObject(val, deliveryAddressList)) {
    deliveryAddressList.push(val)
  }
  localStorage.setItem('deliveryAddress', JSON.stringify(deliveryAddressList))
}
export const saveNearestBranchAddress = (val) => {
  let branchAddressList = JSON.parse(localStorage.getItem('branchAddress') || '[]')
  if (!containsObject(val, branchAddressList)) {
    branchAddressList.push(val)
  }
  localStorage.setItem('branchAddress', JSON.stringify(branchAddressList))
}
export const savedPickupList = () => {
  return JSON.parse(localStorage.getItem('pickupAddress') || '[]')
}

export const savedDeliveryList = () => {
  return JSON.parse(localStorage.getItem('deliveryAddress') || '[]')
}
export const savedNearestBranchList = () => {
  return JSON.parse(localStorage.getItem('branchAddress') || '[]')
}
function containsObject(obj, list) {
  if (isNull(obj)) return true
  var i
  for (i = 0; i < list.length; i++) {
    if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
      return true
    }
  }
  return false
}
export const isValueinObjectArray = (arrayOfObjects, valueToCheck, findkey) => {
  return arrayOfObjects.some((obj) => obj[findkey] === valueToCheck)
}
export const saveRecentSearches = (val) => {
  let recentAddressList = JSON.parse(localStorage.getItem('recentAddress') || '[]')
  if (!containsObject(val, recentAddressList)) {
    recentAddressList.push(val)
  }
  localStorage.setItem('recentAddress', JSON.stringify(recentAddressList))
}
export const getRecentSearches = () => {
  return JSON.parse(localStorage.getItem('recentAddress') || '[]')
}
//near branch
export const saveRecentNearBranchSearches = (val) => {
  let recentAddressList = JSON.parse(localStorage.getItem('recentNearBranchAddress') || '[]')
  if (!containsObject(val, recentAddressList)) {
    recentAddressList.unshift(val)
  }
  localStorage.setItem('recentNearBranchAddress', JSON.stringify(recentAddressList))
}
export const getRecentNearBranchSearches = () => {
  return JSON.parse(localStorage.getItem('recentNearBranchAddress') || '[]')
}

export const incrementGmapAPiCounter = () => {
  const currentCount = localStorage.getItem('gmapAPICounter') || 0

  localStorage.setItem('gmapAPICounter', parseInt(currentCount) + 1)
}
export const isValidGSTNo = (str) => {
  let regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)
  return isNull(str) ? true : regex.test(str) == true
}
export const objToString = (obj, keyValueSeperator = ':') => {
  var str = ''
  for (var p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p) && !isNull(obj[p])) {
      str += p + keyValueSeperator + obj[p]
      str += obj[p].endsWith(',') ? ' ' : ', '
    }
  }
  return str
}
export const getGSTNAddress = (gst) => {
  const { DoorNo, BuildingName, FloorNo, Street, City, State, Pincode } = gst
  return objToString({ 'Door No': DoorNo, 'Building Name': BuildingName, 'Floor No': FloorNo, Street, City, State, Pincode })
}
export const activeClassForDashBoard = (data) => {
  switch (data.toUpperCase()) {
    case 'PAID':
      return 'green activePaymentList'
    case 'PAID (MANUAL)':
      return 'green activePaymentList'
    case 'PAID(MANUAL)':
      return 'green activePaymentList'
    case 'ON ACCOUNT':
      return 'gray activePaymentList'
    case 'ONACCOUNT':
      return 'gray activePaymentList'
    case 'ON ACCOUNT (MANUAL)':
      return 'gray activePaymentList'
    case 'TO PAY':
      return 'orange activePaymentList'
    case 'TOPAY':
      return 'orange activePaymentList'
    case 'TO PAY (MANUAL)':
      return 'orange activePaymentList'
    case 'TOPAY(MANUAL)':
      return 'orange activePaymentList'
    case 'FOC':
      return 'darkGreen activePaymentList'
    case 'COD':
      return 'purple activePaymentList'
    case 'SELF':
      return 'Blue activePaymentList'
    case 'TO PAY DDDV':
      return 'yellow activePaymentList'
    case 'TOPAYDDDV':
      return 'yellow activePaymentList'
    default:
      break
  }
}
export const activeClassForLr = (data) => {
  const normalized = data.replace(/[^A-Z]/gi, '').toUpperCase();

  switch (normalized) {
    // Green
    case 'PAID':
    case 'PAIDMANUAL':
      return 'green activeLrList';

    // Gray
    case 'ONACCOUNT':
    case 'ONACCOUNTMANUAL':
      return 'gray activeLrList';

    // Orange
    case 'TOPAY':
    case 'TOPAYMANUAL':
    case 'TOPAYDDDV':
      return 'orange activeLrList';

    // Dark Green
    case 'FOC':
      return 'darkGreen activeLrList';

    // Purple
    case 'COD':
      return 'purple activeLrList';

    // Blue
    case 'SELFBOOKING':
    case 'SELF':
      return 'Blue activeLrList';

    // Yellow
    case 'TOPAYDDDV':
      return 'yellow activeLrList';

    default:
      break;
  }
};

export const activeClass = (data) => {
  switch (data.toUpperCase()) {
    case 'PAID':
      return 'greentwo'
    case 'PAID(MANUAL)':
      return 'greentwo'
    case 'PAID MANUAL':
      return 'greentwo'
    case 'ON-ACCOUNT':
      return 'graytwo'
    case 'ONACCOUNT':
      return 'graytwo'
    case 'ON-ACCOUNT MANUAL':
      return 'graytwo'
    case 'TO PAY':
      return 'orangetwo'
    case 'TO PAY MANUAL':
      return 'orangetwo'
    case 'FOC':
      return 'darkGreentwo'
    case 'COD':
      return 'purpletwo'
    case 'SELF-BOOKING':
      return 'Bluetwo'
    case 'SELF':
      return 'Bluetwo'
    case 'ToPay(DDDV)':
      return 'yellowtwo'
    default:
      break
  }
}
export const activeClasstwo = (data) => {
  switch (data) {
    case '1':
      return 'greentwo'
    case '6':
      return 'greentwo'
    case '5':
      return 'graytwo'
    case '10':
      return 'graytwo'
    case '2':
      return 'orangetwo'
    case '7':
      return 'orangetwo'
    case '3':
      return 'darkGreentwo'
    case '4':
      return 'purpletwo'
    case 'SELF-BOOKING':
      return 'Bluetwo'
    case '8':
      return 'Bluetwo'
    case '9':
      return 'yellowtwo'
    default:
      break
  }
}
export const parseDate = (str) => {
  const [datePart, timePart, ampm] = str.split(' ');
  const [day, month, year] = datePart.split('-').map(Number);
  const [hours, minutes] = timePart.split(':').map(Number);

  let hour = hours;
  if (ampm === 'PM' && hours !== 12) hour += 12;
  if (ampm === 'AM' && hours === 12) hour = 0;

  return new Date(year, month - 1, day, hour, minutes);
};

//only date
export const formatDate2 = (date) => {
  //08-07-20
  const newDate = date?.split(' ')?.[0]
  const dateArr = newDate.split('-')
  const res = `${dateArr[2]}-${monthNames[dateArr[1] - 1]}-${dateArr[0]}`
  // console.log(res)
  return res
}


export const formatDate3 = (date) => {
const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const dateArr = date.split('-');
  const day = dateArr[0];
  const monthIndex = parseInt(dateArr[1], 10) - 1; // Convert month to zero-based index
  const year = dateArr[2]; // Keep the last two digits of the year

  const res = `${day}-${monthNames[monthIndex]}-${year}`;
  return res;
}
export const parseCustomDate = (dateString) => {
  const [date, time] = dateString.split(' ')
  const [day, month, year] = date.split('-')
  const [hours, minutes] = time.split(':')
  const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month)
  return new Date(`20${year}`, monthIndex, day, hours, minutes)
}
export const ewayBillDateFormat = (ewDate) => {
  if (!ewDate) return ''
  var dateTimeParts = ewDate.split('T')
  var dateStr = dateTimeParts[0]
  var timeStr = dateTimeParts[1]

  var dateParts = dateStr.split('-')
  var year = parseInt(dateParts[0])
  var month = parseInt(dateParts[1]) - 1
  var day = parseInt(dateParts[2])

  var timeParts = timeStr.split(':')
  var hour = parseInt(timeParts[0])
  var minute = parseInt(timeParts[1])
  var second = parseInt(timeParts[2])

  var dateObj = new Date(year, month, day, hour, minute, second)
  return getNewDateTime(dateObj)
}
export const findObjctByValueFromArrayOfObject = (arrayOfObjects, value, findkey, returnKey) => {
  if (returnKey) {
    let returnobj = arrayOfObjects.filter((entry) => entry[findkey] === value)
    return returnobj.length ? returnobj[0][returnKey] : ''
  }
  return arrayOfObjects.filter((entry) => entry[findkey] === value)
}
export const updateObjectInArray = (array, identifierKey, identifierValue, updateKey, updateValue) => {
  const updatedArray = array.map((item) => {
    if (item[identifierKey] === identifierValue) {
      return {
        ...item,
        [updateKey]: updateValue,
      }
    }
    return item
  })

  return updatedArray
}
export const extractAndFilter = (array, prop1, prop2, addAll = false, prop3 = '') => {
  const uniqueObjects = {}
  const filteredArray = []
  if (addAll) {
    filteredArray.push({ name: 'All', id: 0 })
  }
  array.forEach((item) => {
    const value1 = item[prop1]
    const value2 = item[prop2]
    const value3 = item[prop3]
    const uniqueKey = `${value1}-${value2}-${value3}`

    // Check for duplicates
    if (!uniqueObjects[uniqueKey]) {
      uniqueObjects[uniqueKey] = true
      filteredArray.push({ name: value1, id: value2, cityId: value3 })
    }
  })

  return filteredArray
}
export const getDeliveryGst = (intCompanyID, hasGSTOnDelivery, amount, rate, gstFromApi = 0, gstConfig, item, isRCM = false) => {
  let delGstAmount = 0
  if (hasGSTOnDelivery === 1 && [1, 11].includes(intCompanyID)) {
    delGstAmount = amount * rate
  } else if (hasGSTOnDelivery === 1) {
    delGstAmount = gstFromApi
  }
  if (isRCM) delGstAmount = 0
  let taxableAmount = 0
  if (gstConfig?.IsEnableConfig) {
    if (gstConfig.IsDelOptHam) {
      taxableAmount += getNum(item?.ExtraHamli)
    }
    if (gstConfig.IsDelHam) {
      taxableAmount += getNum(item?.HamaliCharges)
    }
    if (gstConfig.IsDem) {
      taxableAmount += getNum(item?.DemurrageChg)
    }
    if (gstConfig.IsCartDel) {
      taxableAmount += getNum(item?.DemurrageChg)
    }
    delGstAmount = getTax(taxableAmount, cf(gstConfig.DeliveryGSTRate))
  }

  return delGstAmount
}
export const getDeliveryGst1 = (intCompanyID, hasGSTOnDelivery, amount, rate, gstFromApi = 0, gstConfig, item, isRCM = false) => {
  let delGstAmount = 0
  if (hasGSTOnDelivery === 1 && [1, 11].includes(intCompanyID)) {
    delGstAmount = amount * rate
  } else if (hasGSTOnDelivery === 1) {
    delGstAmount = gstFromApi
  }
  if (isRCM) delGstAmount = 0
  let taxableAmount = 0
  if (gstConfig?.IsEnableConfig) {
    if (gstConfig.IsDelOptHam) {
      taxableAmount += getNum(item?.ExtraHamli)
    }
    if (gstConfig.IsDelHam) {
      taxableAmount += getNum(item?.Deliverychg)
    }
    if (gstConfig.IsDem) {
      taxableAmount += getNum(item?.DemurrageChg)
    }
    if (gstConfig.IsCartDel) {
      taxableAmount += getNum(item?.AdditionalDeliveryCartage)
    }
    delGstAmount = getTax(taxableAmount, cf(gstConfig.DeliveryGSTRate))
  }
  return delGstAmount
}
function getTax(Amount, taxrate) {
  try {
    return Math.round((Amount * taxrate) / 100)
  } catch (e) {}
}
function cf(x) {
  //convert to float
  var floatValue = +x
  return floatValue
}
export const removeDuplicatesFromArray = (array, property) => {
  const uniqueValues = new Set() // Set to store unique property values
  const uniqueArray = [] // Array to store unique objects

  array.forEach((obj) => {
    const propertyValue = obj[property] // Get the property value of the current object

    if (!uniqueValues.has(propertyValue)) {
      // If property value is not already in the set
      uniqueValues.add(propertyValue) // Add it to the set
      uniqueArray.push(obj) // Add the object to the unique array
    }
  })

  return uniqueArray
}
export const removeDuplicatesFromArray1 = (array, property1, property2) => {
  const uniqueValues = new Set(); // Set to store unique composite keys
  const uniqueArray = []; // Array to store unique objects

  array.forEach((obj) => {
    const compositeKey = `${obj[property1]}_${obj[property2]}`; // Create a composite key

    if (!uniqueValues.has(compositeKey)) {
      // If composite key is not already in the set
      uniqueValues.add(compositeKey); // Add it to the set
      uniqueArray.push(obj); // Add the object to the unique array
    }
  });

  return uniqueArray;
};


export const validateConsignments = (consignmentList) => {
  for (let index = 0; index < consignmentList.length; index++) {
    const element = consignmentList[index]
    if (element.freight == 0) {
      return false
    }
  }
  return true
}
export const validateGoodsValue = (consignmentList) => {
  for (let index = 0; index < consignmentList.length; index++) {
    const element = consignmentList[index]
    if (!element.goods_value || getInt(element.goods_value) === 0) {
      return false
    }
  }
  return true
}
export const invalidMinWeight = (consignmentList, MinWeightPerLR) => {
  const totalChargedWeght = consignmentList.reduce((acc, curr) => acc + +curr.wt_charge, 0)
  if (totalChargedWeght < MinWeightPerLR) return true
  return false
}
export const getLoginToken = (code, loginId, password) => {
  const date = new Date()
  const formattedDate = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).replace(/ /g, '-')
  const formattedTime = date.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit', second: '2-digit' })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  const authString = encrypt([formattedDateTime, 1, code, loginId, password].join('~'))
  return '/?authentication=' + encodeURIComponent(authString)
}

export const openIsolatedTab = (url) => {
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export const getNewDate = () => {
  const date = new Date()
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).replace(/ /g, '-')
}
export const getNewTime = () => {
  const currentDate = new Date()

  const hours = currentDate.getHours().toString().padStart(2, '0')
  const minutes = currentDate.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}
export const getNewDateTime = (currentDate) => {
  if (!currentDate) currentDate = new Date()
  const hours = currentDate.getHours().toString().padStart(2, '0')
  const minutes = currentDate.getMinutes().toString().padStart(2, '0')
  const dayOfWeek = daysOfWeek[currentDate.getDay()]
  const dayOfMonth = currentDate.getDate().toString().padStart(2, '0')
  const month = monthNames[currentDate.getMonth()]
  const year = currentDate.getFullYear()
  return `${hours}:${minutes}, ${dayOfWeek}, ${dayOfMonth}-${month}-${year}`
}

export const redirectToLogin = () => {
  if (window.location.origin.includes('mavenconnect.tech')) window.location.replace('https://mavenconnect.tech/cargo')
  else if (window.location.origin.includes('mavenconnect.biz')) window.location.replace('https://mavenconnect.biz/cargo')
  else window.location.replace('https://mavenconnect.tech/cargo')
}
export const updatePropertyByIndex = (arr, index, propValue = false, propName = 'checked') => {
  // If the object is found, update the property value
  if (index !== -1) {
    arr[index][propName] = propValue
  }

  // Return the updated array
  return arr
}
export const addPropToAllObj = (arr, propValue = false, propName = 'checked') => {
  return arr.map((obj) => ({ ...obj, [propName]: propValue }))
}
export const findprop = (arr, value, dataKey) => {
  let isValue = findObjctByValueFromArrayOfObject(arr, value, dataKey)
  if (isValue.length) {
    isValue = isValue[0]?.checked ? 1 : 0
  } else {
    isValue = 0
  }
  return isValue
}
//Missing Key Add in Dispatch Report
export const addMisssingValue = (data) => {
  const updateData = data?.map((val) => ({
    ...val,
    // SummaryGSTOther
    paidFreight: val.PaymentTypeInt === 1 || val.PaymentTypeInt === 6 ? val.SummaryFreight : 0,
    ToPayCodFreight: val.PaymentTypeInt === 2 || val.PaymentTypeInt === 4 || val.PaymentTypeInt === 7 ? val.SummaryFreight : 0,
    OnAccountFreight: val.PaymentTypeInt === 5 || val.PaymentTypeInt === 10 ? val.SummaryFreight : 0,
    DddvFreight: val.PaymentTypeInt === 9 ? val.SummaryFreight : 0,
    FocFreight: val.PaymentTypeInt === 3 ? val.SummaryFreight : 0,
    SelfFreight: val.PaymentTypeInt === 8 ? val.SummaryFreight : 0,
    totalFreight: val.SummaryFreight,
    paidGstOther: val.PaymentTypeInt === 1 || val.PaymentTypeInt === 6 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage : 0,
    ToPayCodGstOther: val.PaymentTypeInt === 2 || val.PaymentTypeInt === 4 || val.PaymentTypeInt === 7 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage : 0,
    OnAccountGstOther: val.PaymentTypeInt === 5 || val.PaymentTypeInt === 10 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage : 0,
    TopayDddvGstOther: val.PaymentTypeInt === 9 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage : 0,
    FocGstOther: val.PaymentTypeInt === 3 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage : 0,
    SelfGstOther: val.PaymentTypeInt === 8 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage : 0,
    totalGstOther: val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage,
  }))
  return [...updateData]
}
export const addMisssingValueForDetailed = (data) => {
  const updateData = data?.map((val) => ({
    ...val,
    // detailedGSTOther
    paidFreight: val.PaymentTypeInt === 1 || val.PaymentTypeInt === 6 ? val.SummaryFreight : 0,
    ToPayCodFreight: val.PaymentTypeInt === 2 || val.PaymentTypeInt === 4 || val.PaymentTypeInt === 7 ? val.SummaryFreight : 0,
    OnAccountFreight: val.PaymentTypeInt === 5 || val.PaymentTypeInt === 10 ? val.SummaryFreight : 0,
    DddvFreight: val.PaymentTypeInt === 9 ? val.SummaryFreight : 0,
    FocFreight: val.PaymentTypeInt === 3 ? val.SummaryFreight : 0,
    SelfFreight: val.PaymentTypeInt === 8 ? val.SummaryFreight : 0,
    totalFreight: val.SummaryFreight,
    paidGstOther: val.PaymentTypeInt === 1 || val.PaymentTypeInt === 6 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage+val.SummaryAllHamali : 0,
    ToPayCodGstOther: val.PaymentTypeInt === 2 || val.PaymentTypeInt === 4 || val.PaymentTypeInt === 7 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage+val.SummaryAllHamali : 0,
    OnAccountGstOther: val.PaymentTypeInt === 5 || val.PaymentTypeInt === 10 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage+val.SummaryAllHamali : 0,
    TopayDddvGstOther: val.PaymentTypeInt === 9 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage+val.SummaryAllHamali : 0,
    FocGstOther: val.PaymentTypeInt === 3 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage+val.SummaryAllHamali : 0,
    SelfGstOther: val.PaymentTypeInt === 8 ? val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage+val.SummaryAllHamali : 0,
    totalGstOther: val.SummaryGSTOther+val.SummaryInsurance+val.SummaryAllCartage+val.SummaryAllHamali,
  }))
  return [...updateData]
}

//velidate 1 month data function
export const diffInMonths = (g1, g2) => {
  var from = new Date(g1)
  var to = new Date(g2)
  var months = to.getMonth() - from.getMonth() + 12 * (to.getFullYear() - from.getFullYear())

  if (to.getDate() < from.getDate()) {
    var newFrom = new Date(to.getFullYear(), to.getMonth(), from.getDate())
    if (to < newFrom && to.getMonth() == newFrom.getMonth() && to.getYear() % 4 != 0) {
      months--
    }
  }
  return months
}
export const toStr = (value) => {
  if (typeof value === 'string') {
    return value // If the value is already a string, return it as is
  } else if (typeof value === 'number' || typeof value === 'boolean' || value instanceof Date) {
    return value.toString() // For numbers, booleans, and dates, use the toString() method
  } else if (typeof value === 'function') {
    return value.name || value.toString() // For functions, return the function name or the string representation
  } else if (Array.isArray(value)) {
    return value.map(toStr).join(', ') // For arrays, convert each element to a string and join them with commas
  } else if (typeof value === 'object' && value !== null) {
    // For objects, convert key-value pairs to strings and join them with commas
    return Object.entries(value)
      .map(([key, val]) => `${key}: ${toStr(val)}`)
      .join(', ')
  } else {
    return String(value) // For any other type, use the String() constructor
  }
}

export const getFilterWithIdType = (idType) => {
  if (idType === 'Aadhar Card') {
    return getInt
  }
  return false
}
export const getLengthWithIDType = (idType) => {
  if (idType === 'Aadhar Card') {
    return 12
  }
  if (idType === 'PAN Card') {
    return 10
  }
  if (idType === 'Driving Licence') {
    return 16
  }
  return 20
}

export const filterData = (arr, key) => {
  let result = arr?.map((item) => {
    if (item[key] !== '' && item[key] !== null) {
      return item[key]
    } else {
      return
    }
  })
  let finalResult = result?.filter((el) => el !== undefined)
  return finalResult?.filter(onlyUnique)
}

export const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index
}
export function groupByUniqueId(arr, key) {
  const map = new Map();

  for (const item of arr) {
    const uniqueValue = item[key]; // Get the value based on the given key
    if (!map.has(uniqueValue)) {
      map.set(uniqueValue, []);
    }
    map.get(uniqueValue).push(item);
  }

  return Array.from(map.values());
}

export const getPaymentTypeBackground = (paymentType) => {
  switch (paymentType?.toLowerCase()) {
    case 'paid':
      return '#d0f1d2'
    case 'topay':
    case 'to pay':
    case 'to-pay':
    case 'to-pay credit':
      return '#ffe0ea'
    case 'cod':
      return '#ffe0bd'
    case 'topaydddv':
    case 'foc':
      return '#fffdaf'
    case 'onaccount':
    case 'on-account':
      return '#e2e3f3'
    case 'paid(manual)':
    case 'paid manual':
      return '#e8fae9'
    case 'topay(manual)':
    case 'to pay manual':
      return '#ffeff4'
    case 'self':
      return '#c3f8ff'
    case 'onaccount(manual)':
    case 'onaccount manual':
      return '#eeeef8'
    default:
      return ''
  }
}
export function getTrackingUrl() {
  return `https://cargo.mavenconnect.biz/commonlr?p=l&B=${this.BookingID}&U=${this.intUserID}&tab=1`;
}

export const getStatusBackground = (status) => {
  switch (status?.toLowerCase()) {
    case 'booked':
      return '#fff3e0'
    case 'booking transfer':
    case 'booking transferred':
      return '#ffe0b2'
    case 'branch transferred':
      return '#ffe0b2'
    case 'booking received':
      return '#eedbbf'
    case 'branch received':
      return '#fce4ec'
    case 'crossing transferred':
      return '#fce4ec'
    case 'crossing dispatch':
      return '#ffcdd2'
    case 'destination dispatch':
      return '#ffcdd2'
    case 'crossing trans. rec.':
      return '#f8bbd0'
    case 'delivery pending':
      return '#ef9a9a'
    case 'delivered':
      return '#c5e1a5'
    case 'delivered':
      return '#c5e1a5'
    case 'crossing received':
      return '#e0b4b4'
    case 'dispatched':
      return '#c8e6c9'
    case 'dispatched':
      return '#c8e6c9'
    case 'received':
      return '#fof4c3'
    case 'destination dispatch':
      return '#e5def2'
    case 'destination received':
      return '#d6daef'
    case 'delivery transferred':
      return '#cbfof5'
    case 'delivery received':
      return '#e0f7fa'
    case 'delivered':
      return '#a7cecb'
    case 'refund':
      return '#f7c78f'
    case 'received':
      return '#f7c78f'
    default:
      return ''
  }
}

export const getAutoTableColumns = (arr, isSelected = false) =>
  arr
    .filter((item) => !isSelected || item.isSelected)
    .map((item) => ({
      header: item.pdfHead,
      dataKey: item.field,
      xlCol: item.xlCol,
      headerSx: item.headerSx,
    }))
export const distributeValues = (totalValue, parts) => {
  const quotient = Math.floor(totalValue / parts)
  const remainder = totalValue % parts
  const values = []
  for (let i = 0; i < parts; i++) {
    values.push(quotient + (i < remainder ? 1 : 0))
  }
  return values
}

export const getSumOfColumn = (data, columnName) => {
  // Use the reduce method to calculate the sum
  const sum = data.reduce((accumulator, currentValue) => {
    return accumulator + currentValue[columnName]
  }, 0)

  return sum
}

export const backGroundColor = {
  Booked: '#FFF3E0',
  BOOKED: '#FFF3E0',
  'Branch Transfered': '#FFE0B2',
  'Branch Transferred': '#FFE0B2',
  'BRANCH TRANSFERED': '#FFE0B2',
  Received: '#F0F4C3',
  RECEIVED: '#F0F4C3',
  Dispatched: '#C8E6C9',
  DISPATCHED: '#C8E6C9',
  'Branch Received': '#EEDBBF',
  'BRANCH RECEIVED': '#EEDBBF',
  Delivered: '#A7CECB',
  DELIVERED: '#A7CECB',
  'Crossing Branch Received': '#F8BBD0',
  'CROSSING BRANCH RECEIVED': '#F8BBD0',
  'Dest. Received': '#D6DAEF',
  'DEST. RECEIVED': '#D6DAEF',
  'Crossing Received': '#E0B4B4',
  'CROSSING RECEIVED': '#E0B4B4',
  'Crossing Dispatch': '#FFCDD2',
  'Booked Branch Received': '#EEDBBF',
  'BOOKED BRANCH RECEIVED': '#EEDBBF',
  Refund: '#F7C78F',
  REFUND: '#F7C78F',
  'Dest. Branch Received': '#FFCDD2',
  'DEST. BRANCH RECEIVED': '#FFCDD2',
  'Dest. Branch Transferred': '#D6DAEF',
  'DEST. BRANCH TRANSFERRED': '#D6DAEF',
}

export const backGroundColorForStatus = {
  Active: '#E0EFD8',
  Inactive: '#FFF2E2',
}
export const sortTableData = (e, field, sortOrder, type, data) => {
  e.stopPropagation()
  const compareFunction = (a, b) => {
    const compareValue = (order) => (order === 'asc' ? 1 : -1)
    const sortCondition = (field, type) => {
      if (type === 'number') return a[field] - b[field]
      if (type === 'time') return moment(a[field]).valueOf() - moment(b[field]).valueOf()
      return a[field]?.localeCompare(b[field])
    }
    return compareValue(sortOrder) * sortCondition(field, type)
  }
  const sortedData = data.sort(compareFunction)
  return sortedData
}
export const getLocalData = (key) => {
  return new Promise((resolve) => {
    const localData = localStorage.getItem(key)
    resolve(localData ? JSON.parse(localData) : null)
  })
}

export const generateDynamicColumnStyles = (columnCount, Size) => {
  let columnStyles = {}
  let columnIndex = 0
  // Iterate through each header configuration in BranchTransferHeader
  columnCount.forEach((headerConfig) => {
    if (headerConfig?.isSelected) {
      columnStyles[columnIndex] = { ...headerConfig?.pdfColSx, "fontSize": Size };
      columnIndex += 1
    }

  });
  return columnStyles;
}
export const calculateTotalTableWidth = (columns) => {
  let totalWidth = 0;

  columns.forEach((column) => {
    const minCellWidth = column.pdfColSx.minCellWidth;
    totalWidth += minCellWidth;
  });

  return totalWidth;
};

export const calculateDynamicFormatLandscape = (desiredWidth) => {
  const a4LandscapeAspectRatio = 1122 / 793;

  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
  const a4LandscapeAspectRatio = 793 / 1122;

  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const buildCompositeFields = (item, headers) => {
  const result = {}
  headers.forEach(({ field }) => {
    if (!field.includes('^^')) return
    const parts = field.split('^^')
    result[field] = parts
      .map((key) => item[key] ?? '')
      .join('\n')
  })

  return result
}
export function objectKeysToLowerCase(obj){
  Object.keys(obj)?.forEach(function (key) {
      var k = key.toLowerCase();

      if (k !== key) {
          obj[k] = obj[key];
          delete obj[key];
      }
  });
  return (obj);
}
export const copyToClipboard = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};
export function addDaysToDate(date, days) {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + days)
  return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
}
export   function subtractDaysFromDate(date, days) {
  const formattedDate = moment(date, 'YYYY-MM-DD').subtract(days, 'days').format('YYYY-MM-DD')
  return formattedDate
}

export function findRange(arr,val,key1='NOPFrom',key2='NOPUpto') {
  for (let range of arr) {
    if (Number(val) >= range[key1] && Number(val) <= range[key2]) {
      return range;
    }
  }
  return null; // Return null if input doesn't fall within any range
}
export const uploadToS3 = async (file, name) => {
  const ReactS3Client = new S3(ReactS3ClientConfig)
  const timestamp = new Date().getTime()
  const fileType = file.name.split('.').pop()
  const fileName = `${name}_${timestamp}.${fileType}`
  const rs = await ReactS3Client.uploadFile(file, fileName)
    .then((data) => {
      return data.location
    })
    .catch((err) => console.error(err))
  return rs
}

export const Arrow = ({width=11,height=6}) => {
  return (
      <svg width={width} height={height} viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.5 0.5L5.5 5.5L10.5 0.5H0.5Z" fill="#666666" />
      </svg>

  )
}

export const ArrowUp = ({ width = 11, height = 6 }) => {
  return (
      <svg width={width} height={height} viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.666 5.5L5.66602 0.5L0.666016 5.5L10.666 5.5Z" fill="#666666" />
      </svg>
  )
}

export const getCollectableValue = (amount) => {
  if (!amount) return '0'
  amount = +amount
  amount =Math.ceil(amount / 5) * 5
  return amount
}
export const jsPdfDidParseCellCallback = (data, pdfColumns, itemValueColumns) => {
  if (!data.row.raw.isDataRow && data.row.section !== 'head') {
      if (data.row.raw.isSubHeadingRow) {
          if (Array.isArray(data?.row?.raw?.subHeadingData)) {
              let prevColSpan = 0;
              data.row.raw.subHeadingData.forEach((subHeadingObj, index) => {
                  let cellValue = '';
                  if (subHeadingObj.hasOwnProperty('caption'))
                      cellValue += subHeadingObj.caption;
                  if (subHeadingObj.hasOwnProperty('value'))
                      cellValue += ' ' + subHeadingObj.value;
                  const startColSpanIndex = prevColSpan;
                  data.row.cells[startColSpanIndex].text = cellValue;
                  data.row.cells[startColSpanIndex].colSpan = subHeadingObj.colSpan;
                  if (subHeadingObj.hasOwnProperty('rowSpan')) {
                      data.row.cells[startColSpanIndex].rowSpan = subHeadingObj.rowSpan;
                  }
                  data.row.cells[startColSpanIndex].styles.halign = subHeadingObj.align !== undefined ? subHeadingObj.align : "left";
                  data.row.cells[startColSpanIndex].styles.font = "Roboto";
                  data.row.cells[startColSpanIndex].styles.fontSize = "9";
                  if (subHeadingObj.hasOwnProperty('align')) {
                      data.row.cells[startColSpanIndex].styles.halign = subHeadingObj.align;
                  }
                  prevColSpan = startColSpanIndex + subHeadingObj.colSpan;
              });
          }
      }
      else if (data.row.raw.isFooterRow) {
          if (Array.isArray(data?.row?.raw?.footerData)) {
              let prevColSpan = 0;
              data.row.raw.footerData.forEach((footerObj, index) => {
                  let cellValue = '';
                  const startColSpanIndex = prevColSpan;
                  if (footerObj.hasOwnProperty('caption'))
                      cellValue += footerObj.caption;
                  if (footerObj.hasOwnProperty('value'))
                      cellValue += ' ' + footerObj.value;


                  data.row.cells[startColSpanIndex].text = cellValue;
                  data.row.cells[startColSpanIndex].colSpan = 18;
                  data.row.cells[startColSpanIndex].styles.halign = "left";
                  data.row.cells[startColSpanIndex].styles.font = "Roboto";
                  data.row.cells[startColSpanIndex].styles.fontSize = "9";
                  if (footerObj.hasOwnProperty('align')) {
                      data.row.cells[startColSpanIndex].styles.halign = footerObj.align;
                  }
                  prevColSpan = startColSpanIndex + footerObj.colSpan;
              });
          }
      }
      else if (data.row.raw.isSubFooterRow) {
          if (Array.isArray(data?.row?.raw?.subFooterData)) {
              let prevColSpan = 0;
              data.row.raw.subFooterData.forEach((footerObj, index) => {
                  data.row.cells[0].text = footerObj.value;
                  data.row.cells[0].colSpan = 13;
                  data.row.cells[0].styles.halign = "left";
                  data.row.cells[0].styles.font = "Roboto";
                  data.row.cells[0].styles.fontSize = "9";
              });
          }
      }
      else if (data.row.raw.isSignatureRow) {
          if (Array.isArray(data?.row?.raw?.subSignatureData)) {
              let prevColSpan = 0;
              data.row.raw.subSignatureData.forEach((footerObj, index) => {
                  const startColSpanIndex = prevColSpan;
                  data.row.cells[startColSpanIndex].text = footerObj.value;
                  data.row.cells[startColSpanIndex].colSpan = footerObj.colSpan;
                  data.row.cells[startColSpanIndex].styles.halign = footerObj.halign;
                  data.row.cells[startColSpanIndex].styles.font = "Roboto";
                  data.row.cells[startColSpanIndex].styles.fontSize = "9";
                  prevColSpan = startColSpanIndex + footerObj.colSpan;
              });
          }
      }
      else if (data.row.raw.isTotalRow) {
          let prevColSpan = 0;
          if (data.row.raw?.hasOwnProperty('collectionBy')) {
              data.row.cells[prevColSpan].colSpan = data.row.raw?.collectionColSpan;
              data.row.cells[prevColSpan].text = [data.row.raw?.collectionCaption + ' ' + data.row.raw?.collectionBy];
              prevColSpan += data.row.raw?.collectionColSpan;
          }
          data.row.cells[prevColSpan].colSpan = data.row.raw?.colSpan;
          data.row.cells[prevColSpan].text = [data.row.raw?.totalCaption || 'Total'];
          data.row.cells[prevColSpan].styles.halign = data.row.raw?.totalCaptionAllignment !== undefined ? data.row.raw?.totalCaptionAllignment : 'right';
      } else if (data.row.raw.isNoDataRow) {
          data.row.cells[0].colSpan = pdfColumns.length;
          data.row.cells[0].text = [data.row.raw?.rowCaption || ''];
          data.row.cells[0].styles.textColor = [255, 0, 0];
          data.row.cells[0].styles.halign = 'center';
      } else if (data.row.raw.isChildRow) {
          data.row.cells[1].colSpan = data.row.raw.colSpan;
          data.row.cells[1].text = [data.row.raw?.text || ''];
          data.row.cells[1].styles.halign = 'left';
      }
      else if (data.row.raw.isHeaderRow) {
          if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
              data.cell.styles.halign = "right";
          } else {
              data.cell.styles.halign = "left";
          }
      }
  } else if (data.row.section === 'head') {
      if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
          data.cell.styles.halign = "right";
      } else {
          data.cell.styles.halign = "left";
      }
  } else if (data.row.raw.isDataRow && data.row.raw.rowSpan && data.row.raw.rowSpan > 1) {
      data.row.cells[0].rowSpan = data.row.raw.rowSpan;
      data.row.cells[1].styles.valign = 'middle';
  }
}

export const generateChecksum =(requestBody, saltKey)=> {
  // Sort alphabetical keys of create order request body JSON and construct string
  const sortedKeys = Object.keys(requestBody).sort();
  const checksumString = sortedKeys
    .filter(key => key !== 'checksum'&& !(key === 'transferfee' && requestBody[key] === 0)) // Exclude 'checksum' key if present & transferFee if its value is 0
    .map(key => `${key}:${requestBody[key]}`) // Use backticks for template literals
    .join('|');

  // Append salt key
  const checksumStringWithSalt = `${checksumString}|${saltKey}`; // Use backticks for template literals

  // Use SHA256 encryption to generate checksum digest
  const checksumDigest = CryptoJS.SHA256(checksumStringWithSalt).toString();
  return checksumDigest;
}
export const isWithinFourHours = (currentDate, currentTime, journeyDateTime) => {
  const currentDateParts = currentDate.split('-')
  const currentTimeParts = currentTime.split(':')
  const currentDay = parseInt(currentDateParts[2], 10)
  const currentMonth = monthMap[currentDateParts[1]]
  const currentYear = 2000 + parseInt(currentDateParts[0], 10)
  const currentHours = parseInt(currentTimeParts[0], 10)
  const currentMinutes = parseInt(currentTimeParts[1], 10)
  const currentSeconds = parseInt(currentTimeParts[2], 10)

  const currentDateTime = new Date(currentYear, currentMonth, currentDay, currentHours, currentMinutes, currentSeconds)
  const journeyDateTimeObject = new Date(journeyDateTime)
  const timeDifferenceMs = journeyDateTimeObject - currentDateTime
  const timeDifferenceHours = Math.abs(timeDifferenceMs / (1000 * 60 * 60))
  return timeDifferenceHours <= 4
}

export const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    const context = this;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(context, args), delay);
  };
};
export const createCommaSeparatedString = (array, property) => {
  return array
    ?.map((item) => item?.[property])
    .filter(Boolean) // This will remove any undefined or null values
    .join(', ');
};
export const generateContrastingColors = (n) => {
  const baseColors = [];
  for (let i = 0; i < n; i++) {
    const hue = Math.round((360 * i) / n);
    baseColors.push(`hsl(${hue}, 80%, 50%)`);
  }
  const reordered = [];
  let left = 0, right = n - 1;
  while (left <= right) {
    if (left === right) {
      reordered.push(baseColors[left]);
    } else {
      reordered.push(baseColors[left], baseColors[right]);
    }
    left++;
    right--;
  }
  return reordered;
}  
export const setLocalStorage = (key, data, ttlMs = API_CACHE_DURATION * 100) => {
  const record = {
    data,
    expiry: Date.now() + ttlMs,
  }
  localStorage.setItem(key, JSON.stringify(record))
}

export const getLocalStorage = (key) => {
  const cached = localStorage.getItem(key)
  if (!cached) return null

  try {
    const { data, expiry } = JSON.parse(cached)
    if (Date.now() > expiry) {
      localStorage.removeItem(key)
      return null
    }
    return data
  } catch {
    return null
  }
}
export const removeLocalStorage = (key) => {
  localStorage.removeItem(key)
} 
export const downloadTextFile = (data, prefix = 'BookingID_') => {
  const text = Object.entries(data)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n')
  const timestamp = Date.now();
  const fileName = `${prefix}_${timestamp}.txt`;

  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
export function hexToRgb(hex) {
  hex = hex.replace('#', '');
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
}

export async function getMapDistance({ origin, destination, apiKey, travelMode = "DRIVE" }) {
  const response = await fetch(
    "https://routes.googleapis.com/directions/v2:computeRoutes",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Goog-Api-Key": apiKey,
        "X-Goog-FieldMask":
          "routes.duration,routes.distanceMeters,routes.polyline.encodedPolyline",
      },
      body: JSON.stringify({
        origin: { location: { latLng: origin } },
        destination: { location: { latLng: destination } },
        travelMode,
      }),
    }
  );

  const data = await response.json();
  return data;
}

export const customRound = (num) => {
  let decimal = num - Math.floor(num);

  if (decimal <= 0.50) {
    return Math.floor(num);   // round down
  } else {
    return Math.ceil(num);    // round up
  }
}

 export function dateFormatWithInputData(inputDate, format) {
  const date = new Date(inputDate)

  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()

  format = format.replace('MM', month.toString().padStart(2, '0'))

  if (format.includes('yyyy')) {
    format = format.replace('yyyy', year.toString())
  } else if (format.includes('yy')) {
    format = format.replace('yy', year.toString().slice(-2))
  }

  format = format.replace('dd', day.toString().padStart(2, '0'))

  return format
}

// import React from 'react'
// import Modal from '../modal'
// import { useAtom } from 'jotai'
// import { modalAtom } from '../jotaiState/globalStateAtoms'
// import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
// import { CheckCircle, Pending } from '@mui/icons-material'
// import { useTheme } from '@mui/material/styles'

const StatusRow = ({ row, statusIcon }) => (
  <TableRow>
    <TableCell sx={{ fontSize: '15px' }}>{row.label}</TableCell>
    <TableCell>{statusIcon}</TableCell>
  </TableRow>
)

export default function StatusLoaderModal({
  modalKey = 'CommonloaderModal',
  title = 'Loading...',
  list = [],
  labelKey = 'UserName',
  statusKey = 'loaded',
  width = '60%',
}) {
  const [, setModal] = useAtom(modalAtom)
  const theme = useTheme()

  const iconSx = { fontSize: '30px', color: theme.palette.primary.main }

  const statusIconMap = [
    <Pending sx={iconSx} />,
    <CircularProgress sx={iconSx} size={30} />,
    <CheckCircle sx={iconSx} />,
  ]

  return (
    <Modal headTxt={title} width={width} updateModal={setModal}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontSize: '15px' }}>Name</TableCell>
            <TableCell sx={{ fontSize: '15px' }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((item, index) => (
            <StatusRow
              key={index}
              row={{ label: item[labelKey] }}
              statusIcon={statusIconMap[item[statusKey]]}
            />
          ))}
        </TableBody>
      </Table>
    </Modal>
  )
}
